<template>
  <v-container pa-0 fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <template v-for="post of posts">
          <VlogListCard v-if="post.type === 'video'"
                        :key="post.idx"
                        :videoId="post.video_id"
                        :postIdx="post.idx"
                        :type="post.type"
                        :createdAt="post.created_at"
                        :updatedAt="post.updated_at"
                        :menuIdx="post.menu_idx"
                        :nationIdx="post.nation_idx"
                        :title="post.title"
                        :contents="post.contents"
                        :thumbnail="post.thumbnail"
                        :imageList="post.image_list"
                        :bookmarks="post.bookmarks"
                        :channel="post.channels"
                        :viewCnt="post.view_cnt"
                        :likeCnt="post.like_cnt"
                        :likes="post.likes"
                        :commentCnt="post.comment_cnt"
                        @like="likePost(post.idx)"
                        @bookmark="bookmarkPost(post.idx)"
          />
          <PostListCard v-else
                        :key="post.idx"
                        :postIdx="post.idx"
                        :type="post.type"
                        :createdAt="post.created_at"
                        :updatedAt="post.updated_at"
                        :menuIdx="post.menu_idx"
                        :menuName="post.menus ? post.menus.name : null"
                        :nationIdx="post.nation_idx"
                        :nationName="post.nations ? post.nations.name : null"
                        :title="post.title"
                        :contents="post.contents"
                        :thumbnail="post.thumbnail"
                        :imageList="post.image_list"
                        :bookmarks="post.bookmarks"
                        :user="post.user"
                        :viewCnt="post.view_cnt"
                        :likeCnt="post.like_cnt"
                        :likes="post.likes"
                        :commentCnt="post.comment_cnt"
                        @like="likePost(post.idx)"
                        @bookmark="bookmarkPost(post.idx)"
          />
        </template>
      </v-flex>

      <v-flex xs12 class="py-5" v-if="loading">
        <v-progress-circular indeterminate class="mb-4"></v-progress-circular>
      </v-flex>

      <v-flex xs12 class="py-5" v-else-if="!posts.length">
        <div class="caption">여기에 내 이야기를 나누고 싶다면?</div>
        <v-btn small flat class="ma-0" color="#9b9b9b"
               style="min-width: 70px; font-size: 12px; font-weight: 700; letter-spacing: -0.2px; color: #9b9b9b;"
               target="_blank" href="https://www.youthcreator.me/">유스 크리에이터 지원하기</v-btn>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import PostListCard from "@/components/PostListCard";
  import VlogListCard from "@/components/VlogListCard";

  export default {
    name: "Posts",
    components: { PostListCard, VlogListCard },
    props: {
      tourIdx: {
        type: Number,
        required: true,
      },
      menuIdx: {
        type: Number,
        required: true
      },
      activeTab: {
        type: String,
        required: true
      }
    },
    data () {
      return {
        second: parseInt(new Date().getTime() / 1000),
        page: 1,
        maxPage: 2,
        posts: [],
        bottom: true,
        loading: true,
      };
    },
    computed: {
      ...mapGetters('tour', [ 'tourNationIdx' ]),
      isActive () {
        return this.activeTab ? parseInt(this.activeTab.split('-')[1]) === parseInt(this.menuIdx) : true;
      }
    },
    created () {
      this.select(this.tourNationIdx);
      window.addEventListener('scroll', this.bottomVisible);
    },
    destroyed () {
      window.removeEventListener('scroll', this.bottomVisible);
    },
    watch: {
      bottom (bottom, oldBottom) {
        if (this.isActive && bottom && !oldBottom) {
          this.select(this.tourNationIdx);
        }
      },
      tourNationIdx: {
        handler (nationIdx) {
          this.page = 1;
          this.maxPage = 2;
          this.select(nationIdx);
        },
        deep: true,
      }
    },
    methods: {
      ...mapActions('tour', [ 'selectTourGuideMenu' ]),
      ...mapActions('post', [ 'toggleLike', 'toggleBookmark' ]),
      select (nationIdx) {
        if (this.page <= this.maxPage) {
          this.loading = true;
          this.selectTourGuideMenu({
            tourIdx: this.tourIdx,
            menuIdx: this.menuIdx,
            page: this.page,
            second: this.second,
            nationIdx: nationIdx === 0 ? undefined : nationIdx,
          }).then(response => {
            this.page === 1 ? this.posts = response.data : this.posts.push(...response.data);
            this.page++;
            this.loading = false;
          }).catch(err => {
            console.error(err);
            this.loading = false;
          });
        }
      },
      likePost (postIdx) {
        this.toggleLike(postIdx).then(response => {
          this.mutationToggleLike({ idx: postIdx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      bookmarkPost (postIdx) {
        this.toggleBookmark(postIdx).then(response => {
          this.mutationToggleBookmark({ idx: postIdx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      mutationToggleLike ({ idx, flag }) {
        let target = this.posts.find(el => {
          return el.idx === idx;
        });
        if (target.idx === idx) {
          target.likes = flag;
          flag ? target.like_cnt++ : target.like_cnt--;
        }
      },
      mutationToggleBookmark ({ idx, flag }) { // 상세보기 북마크
        let target = this.posts.find(el => {
          return el.idx === idx;
        });
        if (target.idx === idx) {
          target.bookmarks = flag;
          flag ? target.bookmark_cnt++ : target.bookmark_cnt--;
        }
      },
      bottomVisible () {
        const scrollY = window.scrollY;
        const visible = document.documentElement.clientHeight;
        const pageHeight = document.documentElement.scrollHeight;
        const bottomOfPage = visible + scrollY >= pageHeight - 300;
        this.bottom = bottomOfPage || pageHeight < visible;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .caption {
    color: #9b9b9b;
  }
</style>
